// Helper function to get challenge status based on dates
export const getChallengeStatus = (startDate?: string | Date, endDate?: string | Date) => {
  const now = new Date();
  const start = startDate ? new Date(startDate) : now;
  const end = endDate ? new Date(endDate) : null;
  
  // Status mapping
  const STATUS = {
    UPCOMING: { label: 'Upcoming', color: 'warning' as const },
    ONGOING: { label: 'Ongoing', color: 'success' as const },
    PAST: { label: 'Past', color: 'default' as const }
  };
  
  // Determine status
  let statusKey: keyof typeof STATUS;
  
  if (start > now) {
    statusKey = 'UPCOMING';
  } else if (!end) {
    // Evergreen challenge (no end date)
    statusKey = 'ONGOING';
  } else if (end < now) {
    statusKey = 'PAST';
  } else {
    statusKey = 'ONGOING';
  }
  
  return STATUS[statusKey];
}; 